{
  "version": 1,
  "asset_id": "8df13a8a-16e9-4472-ae48-1949d8f1fdb0",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8df13a8a-16e9-4472-ae48-1949d8f1fdb0/band-erosion-egd.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8df13a8a-16e9-4472-ae48-1949d8f1fdb0/band-erosion-egd.webp",
  "original_filename": "band-erosion-egd.webp",
  "size": 177104,
  "content_type": "image/webp",
  "created_at": "2026-11-02T10:46:14Z"
}
